import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CATEGORY, STR_CROPS, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_POST_ITEM, STR_SUBMIT, STR_SUCCESS, STR_UNIT, STR_UNIT_PRICE } from "../Strings";
import NapaAddressPicker from "../ones/NapaAddressPicker";


export default function View(props) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	const [ready, setReady] = useState(false);

	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [category, setCategory] = useState("crop");
	const [unitPrice, setUnitPrice] = useState(0);
	const [unit, setUnit] = useState("pc");
	const [availableQuantity, setAvailableQuantity] = useState(1);
	const [moq, setMoq] = useState(1);
	const [location, setLocation] = useState({});
	const [img1, setImg1] = useState(null);
	const [img2, setImg2] = useState(null);
	const [img3, setImg3] = useState(null);
	

	async function init() {
		setReady(false);
		//..
		setReady(true)
	}

	async function submit() {
		const _img1 = document.getElementById('_img1').files[0];
		const _img2 = document.getElementById('_img2').files[0];
		const _img3 = document.getElementById('_img3').files[0];

		if(title && title.trim().length > 0) {
			if(description && description.trim().length > 0) {
				if(unit && unit.trim().length > 0) {
					if(!isNaN(unitPrice) && Number(unitPrice) > 0) {
						if(!isNaN(availableQuantity) && Number(availableQuantity) > 0) {
							if(!isNaN(moq) && Number(moq) > 0) {
								if(_img1 || _img2 || _img3) {
									if(location.region && location.district && location.ward && location.street) {
										setLoading(true);
										await callApi(
											"post-item",
											{
												title,
												description,
												unit,
												unitPrice,
												availableQuantity,
												moq,
												img1: (_img1 || ''),
												img2: (_img2 || ''),
												img3: (_img3 || ''),
												category,
												location: JSON.stringify(location),
											}
										).then((response) => {
											if(response.status === 1) {
												appContext.tellMessage(STR_SUCCESS[appContext.language]);
												appContext.getMyItems();
												appContext.navBack();
											} else {
												appContext.tellError(response.msg);
											}
										})
										setLoading(false);
									} else {
										appContext.tellError(STR_INVALID_LOCATION[appContext.language]);
									}
								} else {
									appContext.tellError(STR_AT_LEAST_ONE_IMAGE[appContext.language]);
								}
							} else {
								appContext.tellError(STR_INVALID_QUANTITY[appContext.language]);
							}
						} else {
							appContext.tellError(STR_INVALID_QUANTITY[appContext.language]);
						}
					} else {
						appContext.tellError(STR_INVALID_UNIT_PRICE[appContext.language]);
					}
				} else {
					appContext.tellError(STR_INVALID_TITLE[appContext.language]);
				}
			} else {
				appContext.tellError(STR_INVALID_TITLE[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_TITLE[appContext.language]);
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	
	if (ready) {
		return (
			<div className="container">
				<div className="row">
					
					<div className="col-md-12">
						<h6
							className="main-section-title"
						>
							{STR_POST_ITEM[appContext.language]}
						</h6>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">{STR_CATEGORY[appContext.language]}</label>
						<div className="row">
							<div className="col-6">
								<button
									className={(category === 'crop') ? "btn btn-block btn-primary" : "btn btn-outline-primary btn-block"}
									style={{
										height: "70px",
										fontSize: "20px"
									}}
									onClick={() => setCategory('crop')}
								>
									{STR_CROPS[appContext.language]}
								</button>
							</div>

							<div className="col-6">
								<button
									className={(category === 'livestock') ? "btn btn-block btn-primary" : "btn btn-outline-primary btn-block"}
									style={{
										height: "70px",
										fontSize: "20px"
									}}
									onClick={() => setCategory('livestock')}
								>
									{STR_LIVESTOCK[appContext.language]}
								</button>
							</div>

						</div>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">{STR_ITEM_TITLE[appContext.language]}</label>
						<input
							className="form-control"
							value={title}
							onChange={(e) => setTitle(e.target.value)}
						/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">{STR_ITEM_DESCRIPTION[appContext.language]}</label>
						<textarea
							className="form-control"
							value={description}
							onChange={(e) => setDescription(e.target.value)}
							maxLength={500}
						/>
						<div className="form-text">
							Max: 500 chars
						</div>
					</div>

					<div className="col-md-6 mt-2 mb-2">
						<label className="form-label">{STR_UNIT[appContext.language]}</label>
						<input
							className="form-control"
							value={unit}
							onChange={(e) => setUnit(e.target.value)}
							maxLength={6}
						/>
						<div className="form-text">
							kg, pc, debe, gram,
						</div>
					</div>

					<div className="col-md-6 mt-2 mb-2">
						<label className="form-label">{STR_UNIT_PRICE[appContext.language]} {(unit ) ? `(kwa ${unit})` :""}</label>
						<input
							className="form-control"
							value={unitPrice}
							onChange={(e) => setUnitPrice(e.target.value)}
						/>
					</div>

					<div className="col-md-6 mt-2 mb-2">
						<label className="form-label">{STR_AVAILABLE_QUANTITY[appContext.language]}</label>
						<input
							className="form-control"
							value={availableQuantity}
							onChange={(e) => setAvailableQuantity(e.target.value)}
						/>
					</div>

					<div className="col-md-6 mt-2 mb-2">
						<label className="form-label">{STR_MOQ[appContext.language]}</label>
						<input
							className="form-control"
							value={moq}
							onChange={(e) => setMoq(e.target.value)}
						/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">{STR_ITEM_LOCATION[appContext.language]}</label>
						<NapaAddressPicker
							callback={setLocation}
						/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">{STR_IMAGES[appContext.language]}</label>
						<div className="form-text">{STR_AT_LEAST_ONE_IMAGE[appContext.language]}</div>

						<input
							id="_img1"
							type="file"
							accept="image/png, image/jpeg, image/jpg"
							className="form-control mt-1 mb-1"
						/>

						<input
							id="_img2"
							type="file"
							accept="image/png, image/jpeg, image/jpg"
							className="form-control mt-1 mb-1"
						/>

						<input
							id="_img3"
							type="file"
							accept="image/png, image/jpeg, image/jpg"
							className="form-control mt-1 mb-1"
						/>

						
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<button
							className="btn btn-padded btn-block btn-primary btn-rounded"
							onClick={submit}
						>
							{STR_SUBMIT[appContext.language]}
						</button>
					</div>


				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}
	
}